import Vue from 'vue';

const rafMap = new Map();

const mixin = {
	destroyed() {
		for (const id of Array.from(rafMap.values())) {
			if (id) cancelAnimationFrame(id);
		}
	},
	methods: {
		$raf(_key, handler) {
			const key = this.$options.name ? `${this.$options.name}-${_key}` : _key;
			if (rafMap.has(key)) {
				cancelAnimationFrame(rafMap.get(key));
			}
			rafMap.set(key, requestAnimationFrame(handler));
		},
	},
};

const install = (instance = Vue) => instance.mixin(mixin);
export { install, mixin };
